<template>
  <div class="packages-new" :class="{ bg_gray: bg_gray }">
    <div class="container container-lg">
      <h2
        class="f-24 bold uppercase wc-lg packages-new--ttl"
        v-if="_.get(contentData, 'conf.header.title') && windowWidth >= 1207"
      >
        {{ _.get(contentData, "conf.header.title") }}
      </h2>

      <div class="container" v-if="windowWidth <= 1206">
        <h2
          class="f-24 bold uppercase wc-lg packages-new--ttl"
          v-if="_.get(contentData, 'conf.header.title')"
        >
          {{ _.get(contentData, "conf.header.title") }}
        </h2>
      </div>

      <div class="packages-new__inner flex" v-if="windowWidth >= 1207">
        <div
          class="packages-new__table"
          :class="{ layout_2: layout_2, layout_3: conf }"
          v-html="table"
        ></div>
      </div>

      <div class="packages-new__inner" v-else>
        <swiper :options="swiperOptions">
          <swiper-slide class="flex">
            <div
              class="packages-new__table"
              v-html="table"
              :class="{ layout_2: layout_2, layout_3: conf }"
            ></div>
          </swiper-slide>
        </swiper>
        <div class="packages__scrollbar flex j_sb container">
          <div class="packages__scrollbar--line"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Tab from "@/components/modules/Tab";
import TabLayout2 from "@/components/modules/TabLayout2";
import resize_handler from "@/mixins/resize_handler";
export default {
  components: { Tab, TabLayout2 },
  mixins: [resize_handler],
  props: {
    contentData: Object
  },
  data() {
    return {
      swiperOptions: {
        // Booleans

        grabCursor: true,
        watchOverflow: true,

        // Other Options
        slidesPerView: "auto",
        speed: 800,
        slidesOffsetBefore: 47,
        slidesOffsetAfter: 47,
        freeMode: true,
        // Scrollbar

        scrollbar: {
          el: ".packages__scrollbar--line",
          draggable: true,
          hide: false,
          dragSize: 350,
          snapOnRelease: false
        },
        // Responsives
        breakpoints: {
          767: {
            slidesOffsetBefore: 17,
            slidesOffsetAfter: 17,
            scrollbar: {
              dragSize: 137
            }
          }
        }

        // Events
      },
      layout_2: false
    };
  },
  mounted() {
    this.rows;
    this.$nextTick(() => {
      let table = document.querySelectorAll("tbody tr")[1];
      if ([...table.querySelectorAll("td")].length === 3) {
        this.layout_2 = true;
      }
    });
  },
  computed: {
    table() {
      return _.get(this.contentData, "data.list[0].tables");
    },

    conf() {
      let conf = _.get(this.contentData, "conf.conf");
      conf = conf.filter(cf => cf == "layout_2");
      return conf[0];
    },

    bg_gray() {
      let conf = _.get(this.contentData, "conf.conf");
      conf = conf.filter(cf => cf == "bg_gray");
      return conf[0];
    }
  }
};
</script>

<style lang="sass">
.packages-new
  padding-top: 87px
  padding-bottom: 152px

  &--ttl
    margin-bottom: 49px
  &__table
    table
      width: 100%
      border: 1px solid #DCDCDC
      outline: none
      border-spacing: 0px
    tbody
      width: 100%
      td
        position: relative
        border:  none
        padding-top: 28px
        padding-bottom: 28px
        will-change: transform
        font-family: "TBCSailec-Regular"
        a
          position: relative
          background-color: #7063E9
          color: white
          font-family: "TBCSailec-Bold"
          transition: .4s
          cursor: pointer
          height: 60px
          display: flex
          justify-content: center
          align-items: center
          width: calc(100% - 56px)
          border-radius: 6px
          margin: 0 auto
          text-transform: uppercase
          -moz-font-feature-settings: "case"
          -webkit-font-feature-settings: "case"
          font-feature-settings: "case" on
          font-size: 14px
          // padding-left: 41px
          &:before
            position: relative
            content: ''
            background: url('../../assets/imgs/arrow-btn.svg')
            background-size: 100% 100%
            height: 12px
            width: 12px
            margin-right: 8px
          @media (min-width: 1024px)
            &:hover
              background-color: #613DD1
      tr
        &:nth-child(2n+1)
          background-color: #FAFAFA

        td
          border-right: 1px solid #dcdcdc
          ol, ul
            // padding-left: 140px
          ul
            display: flex
            justify-content: center
            li
              position: relative
              display: block
              font-family: "TBCSailec-Regular"
              padding-left: 40px

              &:before
                content: ''
                position: absolute
                background: url('../../assets/imgs/checkbox.png')
                width: 25px
                // left: 99px
                left: 0px
                height: 25px
          ol
            display: flex
            justify-content: center
            padding-left: 0
            li
              position: relative
              display: block
              font-family: "TBCSailec-Regular"
              padding-left: 40px
              &:before
                content: ''
                position: absolute
                background: url('../../assets/imgs/cancel-arrow.png')
                width: 25px
                // left: 99px
                left: 0px
                height: 25px
          &:nth-child(1)
            padding-left: 30px
            padding-right: 24px
        &:not(:last-child)
          td
            border-bottom: 1px solid #dcdcdc
      tr:nth-child(1)
        position: relative
        &:after
          box-shadow: 0px 3px 10px -3px rgba(0, 0, 0, 0.2)
          content: ""
          position: absolute
          bottom: 0
          opacity: 0.3
          left: 0
          width: 100%
          height: 26px
        td
          font-family: "TBCSailec-Bold"
          border-bottom: 1px solid transparent
          padding-left: 30px
          padding-right: 30px
          &:nth-child(1)
            width: 349px
          &:nth-child(2)
            width: 254px
          &:nth-child(3)
            width: 254px
          &:nth-child(4)
            width: 254px
      tr:nth-child(1)
        td
          padding-bottom: 46px
          padding-top: 54px
          background: white
      tr:nth-child(2)
        td
          &:nth-child(2), &:nth-child(3), &:nth-child(4)
            width: 254px
  .packages-new__table.layout_2 tbody tr:nth-child(1) td:nth-child(1),
  .packages-new__table.layout_2 tbody tr:nth-child(1) td:nth-child(2),
  .packages-new__table.layout_2 tbody tr:nth-child(1) td:nth-child(3)
    width: 368px
  .packages-new__table.layout_2 tbody td a
    justify-content: center
  .packages-new__table.layout_2 tbody tr:nth-child(1) td
    padding-left: 26px
    padding-right: 42px
  .packages-new__table.layout_3 tbody td
    padding-left: 26px
  .packages-new__table.layout_3 tbody tr td ol, .packages-new__table.layout_3 tbody tr td ul
    // padding-left: 66px
    display: block
    justify-content: initial
    padding-left: 40px
    margin-top: 0
    margin-bottom: 0
    li 
      margin-bottom: 26px
      padding-left: 0
      position: static
    li:before
      left: 25px

  .packages-new__table.layout_3 tbody td
    padding-right: 37px

  @media (max-width: 1206px)
    .swiper-slide
      width: 1110px
    .container-lg
      padding-left: 0
      padding-right: 0
</style>
